// @core/api/endpoints/admin/list_audit_logs_by_actor.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuditLogsResponse,
} from '../../../types/admin';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/admin';

/**
 * List audit logs by actor (user/service)
 * Returns all audit log entries for actions performed by a specific actor, whether a user or service. Useful for reviewing a user's activity history.
 */
export async function ListAuditLogsByActor(
  actor_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAuditLogsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/admin/audit-logs/actor/:actor_id`;
  requestPath = requestPath.replace(':actor_id', encodeURIComponent(actor_id));
  const requestOptions = options;
  return client.get<ListAuditLogsResponse>(requestPath, { ...requestOptions, params });
}
